import { TableRowDisplayEvent, Label, LookupModelSelectionEvent, TableRow, Textbox, ValidationResult, TableRowCreationEvent, TableRowModeChangeEvent, TableRowMode, LookupModelSearchEvent, DataSourceMode } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { AutogenLayoutMobileCommFilterJunctionInFormTable } from "./autogen/AutogenLayoutMobileCommFilterJunctionInFormTable";

export class MobileCommFilterJunctionInFormTable extends AutogenLayoutMobileCommFilterJunctionInFormTable {
    tableMCFilterJunctionInFormOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = event.getTableRow().data as ModelRow;

        if (tableRow.mode === TableRowMode.QUICK_ADD) {
            const labelTitle = tableRow.findComponentById("labelTitle") as Label;
            labelTitle.marginTop = 12;
        }

        const lmData = modelRow.getLookupModelData("mc_object_id");
        if (lmData) {
            const labelTitle: Label = tableRow.findComponentById("labelTitle") as Label;
            labelTitle.text = lmData[0].get("title");

            const labelVendor: Label = tableRow.findComponentById("labelVendor") as Label;
            labelVendor.text = lmData[0].get("mc_control_id");
        }
    }

    async textboxInFormOnLookupModelSelection(event: LookupModelSelectionEvent) {
        const selectedRow = event.selection;
        if (selectedRow) {
            const tableRow = TableRow.getContainingTableRow(event.target);
            const textboxInForm: Textbox = tableRow.findComponentById("textboxInForm") as Textbox;

            textboxInForm.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
                if (mode === DataSourceMode.SEARCH) {
                    return null;
                }
                const result: ValidationResult = {
                    component: textboxInForm,
                    isValid: true
                }

                // Probably need to do this differently for the form - it is comma delimited
                this.tableMCFilterJunctionInForm.rows.forEach(row =>  {
                    if (event.selection.get("id") === row.data.get("mc_object_id")) {
                        result.isValid = false;
                        result.validationMessage = "Row already exists for this in in form";
                        return;
                    }
                });
                return result;
            };

            const labelTitle: Label = tableRow.findComponentById("labelTitle") as Label;
            labelTitle.text = event.selection.get("title");

            const labelVendor: Label = tableRow.findComponentById("labelVendor") as Label;
            labelVendor.text = event.selection.get("mc_control_id");
        }
    }

    tableMCFilterJunctionInFormOnRowCreate(event: TableRowCreationEvent) {
        const tableRow = event.getTableRow();
        const modelRow = event.getTableRow().data as ModelRow;
        const lmData = modelRow.getLookupModelData("mc_object_id");

        if (lmData) {
            modelRow.set("mc_form.title", lmData[0].get("title"));
            modelRow.set("mc_form.mc_control_id", lmData[0].get("mc_control_id"));
        }
    }

    private textboxInFormBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.form_type = "I";
    }
}
